<template>
  <b-modal :active="value" has-modal-card @close="close()">
    <!-- 追加情報 -->
    <form action="">
      <div class="modal-card" style="width: 800px">
        <header class="modal-card-head">
          <p class="modal-card-title" style="color: whitesmoke">追加情報</p>
        </header>

        <section class="modal-card-body">
          <b-field
            label="療法"
            labelPosition="on-border"
            :type="{ 'is-danger': errors.has('therapy') }"
            :message="errors.first('therapy')"
          >
            <b-select
              expanded
              v-model="info.therapy"
              name="therapy"
              data-vv-as="療法"
              v-validate="'required'"
            >
              <option
                v-for="therapyType in therapyTypes"
                :value="therapyType.code"
                :key="therapyType.code"
              >
                {{ therapyType.name }}
              </option>
            </b-select>
          </b-field>

          <b-field
            label="機器名"
            labelPosition="on-border"
            :type="{ 'is-danger': errors.has('productName') }"
            :message="errors.first('productName')"
          >
            <b-input
              name="productName"
              data-vv-as="機器名"
              v-validate="'required'"
              v-model="productName"
              style="width: 100%"
              :readonly="true"
            ></b-input>
            <b-button
              style="float: right; bottom: 0"
              class="button is-primary has-text-centered"
              icon-left="magnify"
              native-type="button"
              v-on:click="showSelectProduct()"
            ></b-button>
            <select-product
              v-if="isShowSelectProduct"
              name="selectProduct"
              v-model="isShowSelectProduct"
              v-on:set-product="setProduct"
            />
          </b-field>

          <b-field
            label="医療機関名"
            labelPosition="on-border"
            :type="{ 'is-danger': errors.has('hospitalName') }"
            :message="errors.first('hospitalName')"
          >
            <b-input
              name="hospitalName"
              data-vv-as="医療機関名"
              v-validate="'required'"
              v-model="hospitalName"
              style="width: 100%"
              :readonly="true"
            ></b-input>
            <b-button
              style="float: right; bottom: 0"
              class="button is-primary has-text-centered"
              icon-left="magnify"
              native-type="button"
              v-on:click="showSelectHospital()"
            ></b-button>
          </b-field>
          <g-select-patient-customer-form
            v-if="isShowSelectHospital"
            v-model="isShowSelectHospital"
            v-bind:fixedDivision="'ZZZ'"
            v-bind:returnObject="true"
            v-bind:useOfficeCode="true"
            v-on:set-hospital="setHospital"
          />
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="save">決定</button>
          <button class="button" type="button" @click="close()">
            閉じる
          </button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import * as patient from "../../utils/patient";
import selectProductTemplate from "./selectProduct";
import selectHospital from "./SelectPatientForCustomerList";

export default {
  name: "addPatientInfoTemplate",
  components: {
    "select-product": selectProductTemplate,
    "select-patient-customer-form": selectHospital,
  },

  data() {
    return {
      info: {
        therapy: "",
        product: null,
        hospital: null,
        patient: null,
      },
      productName: "",
      hospitalName: "",
      therapyTypes: patient.THERAPY_TYPE_SUMMARY_STATUSES,
      isShowSelectProduct: false,
      isShowSelectHospital: false,
    };
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    patientInfo: {
      type: Object,
      default: null,
    },
  },

  computed: {},

  filters: {},

  methods: {
    save: async function () {
      const validateRes = await this.$validator.validateAll();
      if (!validateRes) {
        return;
      }
      this.info.patient=this.patientInfo;
      this.$emit("add-patient", this.info);
      this.close();
    },
    close: function () {
      this.$emit("input", false);
      return;
    },

    showSelectProduct: function () {
      this.isShowSelectProduct = true;
    },
    setProduct: function (item) {
      this.productName = item.productName;
      this.info.product = item;
    },

    showSelectHospital: function () {
      this.isShowSelectHospital = true;
    },
    setHospital: function (item) {
      this.hospitalName = item.name;
      this.info.hospital = item;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/AddPatientInfo.vue